import React from 'react'

import { units } from 'config/UnitsConfig';


export const Context = React.createContext({
    unit: units.ha,
    setUnit: () => {},
    getUnit: () => {}
});